import { render, staticRenderFns } from "./ReturnBtn.vue?vue&type=template&id=421e06fd&scoped=true&"
import script from "./ReturnBtn.vue?vue&type=script&lang=js&"
export * from "./ReturnBtn.vue?vue&type=script&lang=js&"
import style0 from "./ReturnBtn.vue?vue&type=style&index=0&id=421e06fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e06fd",
  null
  
)

export default component.exports